import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    View,
    ScrollView,
    FlatList,
    TouchableOpacity,
    StyleSheet
} from 'react-native';

import {
    JDText
} from '@jdreact/jdreact-core-lib';

import { get } from '../common/fetch';

import { pt, is_web, fetchLocal } from '../common/utils';

// const { NavigationBar } = JDRouter;

class RelatedCinema extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { cinemaList } = this.props;

        return (
            <View style={ { flex: 1 } }>
                <ScrollView
                    showsVerticalScrollIndicator={ false }
                    style={ { flex: 1, paddingLeft: pt(15), paddingRight: pt(10), backgroundColor: '#fff' } }
                >
                    <FlatList
                        keyExtractor={ (item, index) => index + '' }
                        initialNumToRender={ 10 }
                        data={ cinemaList }
                        renderItem={ this.render_cinema_item }
                    />
                </ScrollView>
            </View>
        );
    }

    componentDidMount() {
        document.title = '相关影院';
        this.getRelatedCinema();
    }

    render_cinema_item = ({ item }) => {
        return (
            <TouchableOpacity
                activeOpacity={ 0.5 }
                style={ st.cinema_item_wrap }
                onPress={ () => this.toMovieList(item.cinemaId) }
            >
                <View style={ st.cinema_name_price_wrap }>
                    <JDText style={ st.cinema_name }>{item.cinemaName}</JDText>
                    <JDText style={ st.cinema_price }>
                        &yen;{item.planPrice / 100}
                        <JDText style={ st.cinema_distance }>起</JDText>
                    </JDText>
                </View>
                <View style={ st.cinema_address_wrap }>
                    <JDText
                        style={ st.cinema_address }
                        numberOfLines={ 1 }
                    >
                        {item.address}
                    </JDText>
                    <JDText style={ st.cinema_km }>{item.cinemaDistanceStr}</JDText>
                </View>
            </TouchableOpacity>
        );
    }

    getRelatedCinema = () => {
        const keyWord = fetchLocal('keyWord');

        const cur_city = fetchLocal('movieCityHistory').rawData[0];

        const lbs = fetchLocal('lbs');

        const data = {
            keyWord,
            cityId: cur_city.cityId,
            lon: lbs?.lon || 0,
            lat: lbs?.lat || 0
        };

        get('searchCinemaMovie', data, true).then((res) => {
            const cinemas = res.data.cinemas || [];

            if (cinemas.length > 0) {
                this.props.dispatch({
                    type: 'cinema_change',
                    cinemaList: cinemas
                });
            }
        }, (err) => {
            console.log(err);
        }).catch((err) => {
            console.log(err);
        });
    }

    toMovieList(cinemaId) {
        this.context.router.toMovieList({ cinemaId });
    }
}

RelatedCinema.contextTypes = {
    router: PropTypes.object
};

const st = StyleSheet.create({
    cinema_item_wrap: {
        paddingVertical: pt(12),
        borderBottomWidth: pt(2),
        borderBottomColor: 'rgba(0,0,0,0.1)'
    },
    cinema_name_price_wrap: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: pt(7)
    },
    cinema_name: {
        fontSize: pt(14),
        color: '#252525',
        marginRight: pt(8)
    },
    cinema_price: {
        fontSize: pt(18),
        color: '#E2231A'
    },
    cinema_address_wrap: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    cinema_address: {
        fontSize: pt(12),
        color: '#898989',
        width: pt(270)
    },
    cinema_distance: {
        fontSize: pt(12),
        color: '#898989'
    },
    cinema_km: {
        fontSize: pt(13),
        color: '#898989'
    }
});

const select = (state) => {
    const { cinemaList } = state.relatedCinema;

    return { cinemaList };
};

export default connect(select, null, null, { withRef: true })(RelatedCinema);
